module.exports = require("sanitize-html");


//////////////////
// WEBPACK FOOTER
// external "sanitize-html"
// module id = 533
// module chunks = 0